import { useTopLevelUser } from "@bokio/contexts/TopLevelUserContext/useTopLevelUser";
import { Notice } from "@bokio/designsystem/components/Notice/Notice";
import { Box } from "@bokio/elements/Box";
import { Bokio as BokioB } from "@bokio/mobile-web-shared/core/model/model";
import { useLazyApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";

import type { Bokio } from "@bokio/mobile-web-shared/core/model/model";

import * as styles from "./broadcastContainer.scss";

export const BroadcastContainer = (props: { targetCategories: Bokio.Common.Broadcast.TargetCategory[] }) => {
	const u = useTopLevelUser();

	const [dismiss] = useLazyApi(proxy.Settings.UserController.DismissNotification.Post);

	const broadcasts = u.user?.Broadcasts.filter(
		n =>
			n.TargetCategories.some(loc => props.targetCategories.includes(loc)) &&
			n.AffectedCompanyIds.some(c => c === u.companyInfo?.Id),
	);

	if (!broadcasts || broadcasts.length === 0) {
		return null;
	}

	return (
		<Box>
			<div className={styles.container}>
				{broadcasts.map((n, i) => (
					<Notice
						color={
							n.Level === BokioB.Common.Broadcast.Level.Information
								? "info"
								: n.Level === BokioB.Common.Broadcast.Level.Warning
									? "warning"
									: "warning"
						}
						key={i}
						collapsible={false}
						dismissible={n.Dismissible}
						onDismiss={() => dismiss({ NotificationId: n.Id })}
					>
						{n.Message}
					</Notice>
				))}
			</div>
		</Box>
	);
};
